import type { ReactNode } from 'react';
import { formatCurrency, formatQuantity } from '../../utils/formatCurrency';

export type ProductListTotalsBarMode = 'selected' | 'page';

export interface ProductListTotalsBarProps {
  mode: ProductListTotalsBarMode;
  count: number;
  qtyOnHand: number;
  stockValue: number;
  pageCountSuffix?: string;
  onClear?: () => void;
  children?: ReactNode;
}

const ProductListTotalsBar = ({
  mode,
  count,
  qtyOnHand,
  stockValue,
  pageCountSuffix = '',
  onClear,
  children,
}: ProductListTotalsBarProps) => {
  const countLabel =
    mode === 'selected'
      ? `${count} selected`
      : `Totals (${count}${pageCountSuffix})`;

  return (
    <div className="z-20 flex flex-shrink-0 flex-wrap items-center justify-between gap-3 border-t border-gray-200 bg-white px-4 py-3 shadow-[0_-4px_12px_rgba(0,0,0,0.06)]">
      <div className="flex flex-wrap items-center gap-x-6 gap-y-1 text-sm">
        <span className="font-medium text-gray-900">{countLabel}</span>
        <span className="text-gray-600">
          On hand{' '}
          <span className="font-medium font-mono text-gray-900">
            {formatQuantity(qtyOnHand)}
          </span>
        </span>
        <span className="text-gray-600">
          Stock value{' '}
          <span className="font-medium font-mono text-gray-900">
            {formatCurrency(stockValue)}
          </span>
        </span>
      </div>
      <div className="flex items-center gap-3 flex-wrap">
        {children}
        {mode === 'selected' && onClear && (
          <button
            type="button"
            onClick={onClear}
            className="text-sm text-slate-700 underline hover:text-slate-900"
          >
            Clear selection
          </button>
        )}
      </div>
    </div>
  );
};

export default ProductListTotalsBar;
